<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019-2020 (original work) Open Assessment Technologies SA ;
    export let data;

    $: label = data && data.label;
</script>

<style>
    .visually-hidden {
        @add-mixin visually-hidden;
    }
</style>

{#if label}
    <div aria-hidden="true">{data.data}</div>
    <div class="visually-hidden">{label}</div>
{:else}
    {data.data}
{/if}
